import qs from 'qs';
import type { JsonBodyRequest } from './jsonapi';
import type { ApptegyAccount } from '@@/types/Users';
export function SerializeQueryParams(params) {
  return qs.stringify(params, { arrayFormat: 'brackets' });
}

export type IGeneralInfo = {
  lastName: string;
  firstName: string;
  email: string;
  phoneNumber: string;
  locale: string;
  id?: string;
};

export type JSONApiUser = {
  name: string;
  'given-name': string;
  'family-name': string;
  email: string;
  'phone-number': string;
  locale: string;
  id?: string | number;
  'client-id'?: string | number;
};
export type JSONApiApptegyAccount = {
  'user-id': string;
  'oauth-application-id': number;
  role: string;
  settings: unknown;
};

export function SerializeUserPayload(
  data: IGeneralInfo,
  clientId?: string | number,
  userId?: string | number,
): JsonBodyRequest<JSONApiUser> {
  const payload: JSONApiUser = {
    name: `${data.firstName} ${data.lastName}`,
    'given-name': data.firstName,
    'family-name': data.lastName,
    email: data.email || null,
    'phone-number': data.phoneNumber || null,
    locale: data.locale || null,
  };
  if (clientId) {
    payload['client-id'] = clientId;
  }
  return {
    data: {
      attributes: payload,
      type: 'users',
      id: userId,
    },
  };
}

export function serializeApptegyAccountPayload(data: ApptegyAccount): JsonBodyRequest<JSONApiApptegyAccount> {
  return {
    data: {
      attributes: {
        'user-id': data.userId,
        'oauth-application-id': data.oauthApplicationId,
        role: data.role,
        settings: data.settings,
      },
      type: 'apptegy-accounts',
      id: data.id,
    },
  };
}
